export const validUrl = value => {
  try {
    // eslint-disable-next-line no-unused-vars
    const url = new URL(value)
    return true
  } catch (e) {
    return false
  }
}
